import axios from 'axios';
import siteConfig from '@config';

/**
 * Exchanges a report id for a short-lived presigned download URL.
 *
 * The endpoint takes the id and nothing else — never a caller-supplied bucket
 * or key — and re-verifies the caller's role plus their `usertoprograms` row
 * for the report's program before it presigns, so the authorization does not
 * depend on this call site.
 *
 * Lives in the event-handlers Netlify site, NOT this portal's own `functions/`
 * — a relative `/.netlify/functions/...` path would 404. Cross-site calls go
 * through `hopdriveEventsUrl`, the per-environment base URL every deployed
 * config defines, mirroring decodeVin.ts.
 */
export const fetchProgramReportUrl = async (reportId: number, token?: string): Promise<string> => {
  const res = await axios({
    method: 'POST',
    url: `${siteConfig.hopdriveEventsUrl}/.netlify/functions/app-get-program-report-url`,
    data: { reportId },
    headers: { authorization: `Bearer ${token}` },
  });

  const url = res?.data?.url;
  if (!url) throw new Error(`No download URL returned for report ${reportId}`);
  return url;
};
